<div class="aba-empresa">
  <div class="bloco-empresa">
        <div class="col">
      <div class="bloco-tipos-empresas">
        <a (click)="navigateTo('novo')">
          <div class="item-header">
            <h2>Empresas</h2>
          </div>
          <p>Nova experiência de busca por empresas.</p>
        </a>
      </div>
    </div>
    <div class="linha"></div>
    <div class="col">
      <div class="bloco-tipos-empresas">
        <a (click)="navigateTo('salvas')">
          <div class="item-header">
            <span>Buscas salvas por</span>
            <h2>Empresa</h2>
          </div>
          <p>Veja suas buscas de empresas salvas.</p>
        </a>
      </div>
    </div>
  </div>
</div>
